import { render, staticRenderFns } from "./supplierYCL.vue?vue&type=template&id=c60a2ce8&scoped=true&"
import script from "./supplierYCL.vue?vue&type=script&lang=js&"
export * from "./supplierYCL.vue?vue&type=script&lang=js&"
import style0 from "./supplierYCL.vue?vue&type=style&index=0&id=c60a2ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60a2ce8",
  null
  
)

export default component.exports